import axios from "@/plugins/axios";
import Vue from "vue";
import utils from "@/stores/utils";

const state = {
    catalog: {},
    catalog_saving: false,
    catalog_saving_errors: {},

    stats: null,
};

const mutations = {

    updateCatalog(state, catalog) {
        state.catalog = catalog;
        state.catalog_loading = false;
        state.catalog_loading_errors = null;
    },

    updateCatalogSaving(state, saving) {
        state.catalog_saving = saving;
    },
    updateCatalogSavingErrors(state, errors) {
        state.catalog_saving_errors = errors || {};
    },
    updateProvider(state, provider) {
        Vue.set(state.catalog, "provider_data", provider || null);
        state.catalog.provider = provider?.id || null;
        state.catalog.copy_from = null;
    },
};

const actions = {

    async saveCatalog({ commit, dispatch, state }, params) {
        commit("updateCatalogSaving", true);
        commit("updateCatalogSavingErrors", null);

        let url = "/api/catalogs/";
        let method = axios.post;

        if (params.instance.id) {
            url = `/api/catalogs/${params.instance.id}/`;
            method = axios.put;
        }
        try {
            const response = await method(url, params.instance);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateCatalogSavingErrors", error.details);
            throw error;
        } finally {
            commit("updateCatalogSaving", false);
        }
    },

    async init({ commit, dispatch, state }, params) {
        await commit("updateCatalog", params.catalog || {});
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
